module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/correct-05ea8786bf1fc081a4a84cae0df81833.svg&quot;;"